import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: '1',
        title: 'Web development',
        description: 'We cover a massive range of solutions. We customize clients need according to the project requirements.'
    },
    {
        icon: '2',
        title: 'Design & Creative',
        description: 'We play with color, images, graphics, adobe Photoshop, typography, UI/UX designing to design your vision.'
    },
    {
        icon: '3',
        title: 'App Development',
        description: 'We developing and coding ideas through strategies, app development (Android and IOS).'
    },
    {
        icon: '4',
        title: 'Product Designer',
        description: '  We have a wide variety of marketing like search engine marketing, social media marketing, content marketing.'
    },
]

const ServiceFour = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                <div className="line"></div>
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceFour;